<template>
  <component :is="link ? 'inertia-link' : 'div'" :class="className" v-bind="$attrs">
    <sg-spacing :x-sm="padded" :y-sm="padded">
      <slot />
    </sg-spacing>
  </component>
</template>

<script>
export default {
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Boolean,
      default: false,
    },
    padded: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    className() {
      return [
        'bg-white block border border-gray-100 transition duration-150 ease-in-out shadow-md rounded-2xl',
        this.hover && 'hover:shadow-lg overflow-hidden',
        this.link && 'hover:bg-gray-50 hover:shadow-lg overflow-hidden',
      ];
    },
  },
};
</script>
